import { Modal, Form, IFormContext } from 'rewire-ui';
import { GroupUpdateInput, IGroup }  from '../DataTypes';
import DataMutations                 from '../graphql/Mutations';
import mainPageModel                 from '../main-navigation/MainPageModel';
import { notifications }             from '../ui/Notifications';

export interface IRenameGroupDialogData {
  group: IGroup;
}

export class RenameGroupDialogModel extends Modal {
  form:     Form;
  groupId?: string;

  constructor() {
    super('Rename Group');
    this.form = Form.create((form: IFormContext) => ({
      name: form.string().label('Name').validators('required').placeholder('enter group name').autoFocus(),
    }), {}, {updateOnChange: true});
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit', disabled: () => !this.form.hasChanges });
  }

  reset() {
    this.form.reset();
    this.groupId = undefined;
  }

  load(data: IRenameGroupDialogData) {
    this.reset();
    this.groupId    = data.group.id;
    this.form.value = {name: data.group.name};
    this.open();
  }

  private save = async (): Promise<boolean> => {
    const groupUpdateInput: GroupUpdateInput = {
      id:   this.groupId!,
      name: this.form.field.name.value,
    };
    const result = await DataMutations.updateGroups('', [groupUpdateInput]);

    if (result && result[0]) {
      notifications.success('Group Renamed');
      mainPageModel.updateAreasAndGroups();
      return true;
    }

    notifications.error('Group Renaming Failed');
    return false;
  };

  submit = async () => {
    return await this.form.submitAsync(this.save);
  };
}

const renameGroupDialogModel = new RenameGroupDialogModel();
export default renameGroupDialogModel;
